import React from 'react';
import styled from '@emotion/styled';
import { SubmitButton } from '../../../../shared/components';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { theme } from '../../../../shared/styles';
import { IBookingSummarySubmitProps } from '../shared/summary/IBookingSummarySubmitProps';

export const ExtrasSubmit = ({
	shouldProceedWithoutPay,
}: IBookingSummarySubmitProps) => {
	const { t } = useTranslation();
	const submitLabel = shouldProceedWithoutPay
		? t('web_parking_extras_submit_button_proceed')
		: t('web_parking_extras_submit_button');

	return <StyledSubmitButton>{submitLabel}</StyledSubmitButton>;
};

const StyledSubmitButton = styled(SubmitButton)`
	font-family: inherit;
	align-items: center;
	border-radius: 4px;
	box-shadow: 0px -3px 0px 0px #005b99 inset;
	outline: none;
	justify-content: center;

	&:focus-visible {
		outline: ${theme.button?.primary?.focus?.outline};
	}
`;
